import { TemplatesContainerContext } from "./context"
import { Route, Routes } from "react-router-dom"
import { ERoutes } from "../../utils/url"
import { fetchRoute } from "@cakemail-org/ui-components-v2"
import TemplatesListing from "../templates/container/listing"
import TemplateDetails from "../templates/container/details"
import { ETemplateSubNav } from "./types"


export default function EmailTemplates({ ...props }) {
    return <TemplatesContainerContext.Provider value={{}}
    >
        <Routes>
            <Route index path={fetchRoute({ route: ERoutes.templates })} element={<TemplatesListing />} />
            <Route path={fetchRoute({ route: ERoutes.templateDetails })} element={<TemplateDetails initTab={ETemplateSubNav.details} />} />
            <Route path={fetchRoute({ route: ERoutes.templateSharing })} element={<TemplateDetails initTab={ETemplateSubNav.sharing} />} />

            <Route index path={"/"} element={<TemplatesListing />} />
            <Route path={"/:templateId"} element={<TemplateDetails initTab={ETemplateSubNav.details} />} />
            <Route path={"/:templateId/sharing"} element={<TemplateDetails initTab={ETemplateSubNav.sharing} />} />

        </Routes>
    </TemplatesContainerContext.Provider>
}